export const state = {
    info: null,
    comics: [],
    comics_obj: {},
    chapters_obj: {},
    votes: {},
    vote_token: null,
    route: null,
};
